"use strict";exports.unpackMessage=function(e,s,a){var n=e[0],r=e[1],t=e[2],c=e[3],u=e[4],p=e[5],i=e[6];return[n,r+s,a[t].namespace,c,u,p,i]};
//# sourceMappingURL=unpackMessage.cjs.map
